import { getApiInstance } from "../../../api";
import mutationWrapper from "../../mutationWrapper";
import ApiClient from "../../../apiClient";

export async function authenticate(data: { token: string }) {
  const res = await ApiClient.get(`/Authenticate?token=${data.token}`);
  return res.data;
}

export const useAuthenticate = mutationWrapper(authenticate);
